import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const Review = () => {

    const { id, sha_ini, sha_fix } = useParams();

    const [ori_commit, setOri_commit] = useState(null);

    const [review, setReview] = useState({
        review: {
            owner: null,
            name: null,
            pr_id: null,
            keywords: [],
            security: null
        },
        comment: {
            message: null,
            author: null,
            diff_hunk: '',
            path: null,
            original_line: 0
        },
        original_commit: {
            sha: null,
            message: '',
            file: null,
            path: null,
            file_formated: []
        },
        fix_commit: {
            sha: null,
            message: '',
            file: null,
            path: null,
            file_formated: []
        }
    });

    const [otherCommits, setOtherCommits] = useState([]);

    function formatMessage(message) {
        const messageList = message.split('\n');
        return messageList.map((line) => {
            return <div className="text-left whitespace-pre-wrap break-word">{line}</div>;
        });
    }

    function formatFile(file) {
        let num = 0
        let pasnum = 0
        return file.map((line) => {
            if (line.type === 'plus') num++;
            else if (line.type === 'minus') pasnum++;
            else {
                num++;
                pasnum++;
            }

            return <div className={`text-left whitespace-pre-wrap break-words ${line.type === 'plus' ? 'bg-green-300' : line.type === 'minus' ? 'bg-red-300' : ''}`}>
                {line.type === 'minus' ? pasnum : num} {line.line}
            </div>;
        });
    }

    function formatDiff(diff) {
        const diffList = diff.split('\n');
        let num = 0;
        let numMinus = 0;
        return diffList.map((line) => {
            let type = '';

            let n = num

            if (line.startsWith('@@')) {
                num = parseInt(diffList[0].split('@@')[1].split('+')[1].split(',')[0]);
                numMinus = parseInt(diffList[0].split('@@')[1].split('+')[0].split('-')[1].split(',')[0]);
                n = ''
            }
            else if (line.startsWith('-')) {
                n = numMinus;
                numMinus++;
            }
            else if (line.startsWith('+')) {
                n = num;
                num++;
            }
            else {
                n = num;
                num++;
                numMinus++;
            }

            if (line.startsWith('+')) type = 'bg-green-300';
            else if (line.startsWith('-')) type = 'bg-red-300';
            return <div className={`text-left whitespace-pre-wrap break-word ${type}`} id={`${n} ${line} ${type}`}>{n} {line}</div>;
        });
    }

    function eval_review() {
        let isSecurity = document.getElementById('isSecurity').value;
        let reason = document.getElementById('reason').value;
        let correct = document.getElementById('correct').value;
        let comment = document.getElementById('comment').value;

        if (isSecurity === 'Select' || reason === '' || correct === 'Select') {
            alert('Please fill all fields');
            return;
        }

        fetch(process.env.REACT_APP_BACKEND_URL + 'eval_review', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
                id: id,
                sha_ini: sha_ini,
                sha_fix: sha_fix,
                isSecurity: isSecurity === 'true',
                reason: reason,
                correct: correct === 'true',
                comment: comment
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.res === 'ok') {
                    alert('Review evaluated');
                } else {
                    alert('Error evaluating review');
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });

    }

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_review/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setReview(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [id, sha_ini, sha_fix]);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_eval/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user"), reviewer: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.security === null) document.getElementById('isSecurity').value = 'Select';
                else document.getElementById('isSecurity').value = data.security ? 'true' : 'false';
                if (data.correct === null) document.getElementById('correct').value = 'Select';
                else document.getElementById('correct').value = data.correct ? 'true' : 'false';
                document.getElementById('reason').value = data.reason;
                document.getElementById('comment').value = data.comment;
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [id, sha_ini, sha_fix]);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_other_commits/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setOtherCommits(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [id, sha_ini, sha_fix]);

    useEffect(() => {
        if (review.review.owner === null) return;
        if (review.review.name === null) return;
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_comment/' + id + '/' + sha_ini + '/' + sha_fix, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user"), name: review.review.name, owner: review.review.owner }),
        })
            .then(response => response.json())
            .then(data => {
                setOri_commit(data.original_commit_id);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [id, sha_ini, sha_fix, review.review.name, review.review.owner]);


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Review</h1>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12 grid md:grid-cols-4 gap-4 sm:grid-cols-1">
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Repository:</h1>
                    <p>{review.review.owner}/{review.review.name}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Pull Request:</h1>
                    <p>{review.review.pr_id}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">File:</h1>
                    <p>{review.comment.path}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL:</h1>
                    <Link target="_blank" to={'https://github.com/' + review.review.owner + '/' + review.review.name + '/pull/' + review.review.pr_id}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{review.review.owner}/{review.review.name}/pull/{review.review.pr_id}
                        </p>
                    </Link>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL comment:</h1>
                    <Link target="_blank" to={'https://github.com/' + review.review.owner + '/' + review.review.name + '/pull/' + review.review.pr_id + '/files/' + ori_commit}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{review.review.owner}/{review.review.name}/pull/{review.review.pr_id}/files/{ori_commit}
                        </p>
                    </Link>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Evaluation:</h1>
                </div>
                <div className="grid md:grid-cols-4 gap-4 sm:grid-cols-1">
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Is Security:</label>
                        <select id="isSecurity" className="w-full">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Reason:</label>
                        <textarea type="text" id="reason" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Correct:</label>
                        <select className="w-full" id="correct">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Comment:</label>
                        <textarea type="text" id="comment" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>

                <div className="mt-4 flex grid justify-items-end gap">
                <button onClick={eval_review}
                    className="rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-800"
                >
                    Evaluate
                </button>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="grid md:grid-cols-2 gap-2 sm:grid-cols-1">
                    <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96">
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Comment:</h1>
                        <p>{review.comment.message}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Author:</h1>
                        <p>{review.comment.author}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Original Line:</h1>
                        <p>{review.comment.original_line}</p>
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Keywords:</h1>
                        <p>{review.review.keywords.join(', ')}</p>
                    </div>

                    <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96">
                        <h1 className="text-base font-semibold leading-7 text-gray-900">Diff Hunk:</h1>
                        <div>{formatDiff(review.comment.diff_hunk)}</div>
                    </div>
                </div>
            </div>

            <div className="m-5 grid md:grid-cols-2 gap-4 sm:grid-cols-1">
                <div className="col-span-1 shadow-md p-3">
                    <h1 className="text-base font-semibold leading-7 text-gray-900 break-words">Original Commit:</h1>
                    <Link target="_blank" to={'https://github.com/' + review.review.owner + '/' + review.review.name + '/pull/' + review.review.pr_id + '/commits/' + review.original_commit.sha}>
                        <p className="text-blue-500 hover:underline break-words">
                            https://github.com/{review.review.owner}/{review.review.name}/pull/{review.review.pr_id}/commits/{review.original_commit.sha}
                        </p>
                    </Link>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Message:</h1>
                    <p>{formatMessage(review.original_commit.message)}</p>
                </div>
                <div className="col-span-1 shadow-md p-3">
                    <h1 className="text-base font-semibold leading-7 text-gray-900 break-words">Fix Commit:</h1>
                    <Link target="_blank" to={'https://github.com/' + review.review.owner + '/' + review.review.name + '/pull/' + review.review.pr_id + '/commits/' + review.fix_commit.sha}>
                        <p className="text-blue-500 hover:underline break-words">
                            https://github.com/{review.review.owner}/{review.review.name}/pull/{review.review.pr_id}/commits/{review.fix_commit.sha}
                        </p>
                    </Link>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Message:</h1>
                    <p>{formatMessage(review.fix_commit.message)}</p>
                </div>

                <div className="col-span-1 overflow-y-auto h-96">
                    {formatFile(review.original_commit.file_formated)}
                </div>
                <div className="col-span-1 overflow-y-auto h-96">
                    {formatFile(review.fix_commit.file_formated)}
                </div>

            </div>

            <div className="m-5">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Other Possible Fix Commits</h1>
                    {otherCommits.map(commit => (
                        <div className="grid md:grid-cols-1 gap-4 sm:grid-cols-1">
                            <div className="col-span-1 shadow-md p-3">
                                <Link target="_blank" to={'https://github.com/' + review.review.owner + '/' + review.review.name + '/pull/' + review.review.pr_id + '/commits/' + commit}>
                                    <p className="text-blue-500 hover:underline break-words">
                                        https://github.com/{review.review.owner}/{review.review.name}/pull/{review.review.pr_id}/commits/{commit}
                                    </p>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default Review;